import { FC, useContext } from 'react';
import { Menu } from '@chakra-ui/react';

import {
  ApplicationContext,
  DocumentDetailsViewActionContext,
} from '~/core/middle-office/components/application';

export const ModalMenuItemComponent: FC = () => {
  const { actionContexts } = useContext(ApplicationContext);
  const {
    action: { text, key },
  } = useContext(DocumentDetailsViewActionContext);

  const { modal } = actionContexts[key];

  return (
    <Menu.Item onClick={modal.onOpen} value={`action-${key}`}>
      {text}
    </Menu.Item>
  );
};
